import axios from "axios";
import config from "./config";

export const changePassword = (body) => {
  return axios.post("/users/change-password", body, config);
}
